// initial state
// shape: [{ id, quantity }]
const state = () => ({
  items: [],
  countDishNoPrice: 0,
  countDish: 0,
  checkoutStatus: null,
});

// getters
const getters = {
  // eslint-disable-next-line no-unused-vars
  cartProducts: (state, getters, rootState) => {
    /*
    return state.items.map(({ id, quantity }) => {
      const product = rootState.products.all.find(product => product.id === id)
      return {
        title: product.title,
        price: product.price,
        quantity
      }
    })*/
    return state.items;
  },

  // eslint-disable-next-line no-unused-vars
  countDish: (state, getters, rootState) => {
    return state.countDish;
  },

  // eslint-disable-next-line no-unused-vars
  cartTotalPrice: (state, getters, rootState) => {
    return getters.cartProducts.reduce((total, dish) => {
      /*
      let menu = rootState.location.menus.find(x => x.id == dish.menuid);
      if (menu.hide_price == 0){
        return total + dish.price * dish.quantity;
      }
      */
      if (dish.hide_price == 0) {
        return total + dish.price * dish.quantity;
      }

      return total;
    }, 0);

    /*
    return getters.cartProducts.reduce((total, product) => {
      return total + product.price * product.quantity
    }, 0)
    */
  },

  countDishNoPrice: (state) => {
    return state.countDishNoPrice;
  },
};

// actions
const actions = {
  /*
  checkout ({ commit, state }, products) {
    const savedCartItems = [...state.items]
    commit('setCheckoutStatus', null)
    // empty cart
    commit('setCartItems', { items: [] })
    shop.buyProducts(
      products,
      () => commit('setCheckoutStatus', 'successful'),
      () => {
        commit('setCheckoutStatus', 'failed')
        // rollback to the cart saved before sending the request
        commit('setCartItems', { items: savedCartItems })
      }
    )
    
  },*/

  setItems({ commit }, items) {
    commit("setCartItems", items);
  },

  setCountDish({ commit }, count) {
    commit("setCountDish", count);
  },

  setCountDishNoPrice({ commit }, count) {
    commit("setCountDishNoPrice", count);
  },

  addQuantity({ state, commit }, dish) {
    commit("setCheckoutStatus", null);
    //const cartItem = state.items.find(item => item.id === dish.id)
    const cartItem = state.items.find(
      (item) => item.id === dish.id && item.menuid === dish.menuid
    );

    if (cartItem) {
      commit("incrementItemQuantity", cartItem);

      if (dish.unit != "€" && dish.unit != "€/calice") {
        commit("addDishNoPrice");
      }
    }
  },

  removeQuantity({ state, commit }, dish) {
    commit("setCheckoutStatus", null);
    //const cartItem = state.items.find((item) => item.id === dish.id);
    const cartItem = state.items.find(
      (item) => item.id === dish.id && item.menuid === dish.menuid
    );
    if (cartItem) {
      commit("decrementItemQuantity", cartItem);

      if (dish.unit != "€" && dish.unit != "€/calice") {
        commit("removeDishNoPrice");
      }
    }
  },

  addProductToCart({ state, commit, rootState }, { dish, menu }) {
    commit("setCheckoutStatus", null);
    const cartItem = state.items.find(
      (item) => item.id === dish.id && item.menuid === menu.id
    );
    if (!cartItem) {
      let clone = Object.assign({}, dish);
      clone.quantity = 1;
      clone.note = "";
      clone.incremental = dish.incremental;
      clone.menuposition = menu.position;
      clone.showNote = false;
      clone.menuid = menu.id;
      clone.hide_price = menu.hide_price;
      clone.menu_type_id = menu.menu_type_id;
      clone.menuname = menu.translations.find(
        (item) => item.locale === rootState.locale
      ).name;
      commit("pushProductToCart", clone);
    } else {
      //cartItem.menuid = menu.id;
      //cartItem.menuname = menu.translations.find(item => item.locale === rootState.locale).name;
      commit("incrementItemQuantity", cartItem);
    }

    if (dish.unit != "€" && dish.unit != "€/calice") {
      commit("addDishNoPrice");
    }
    // remove 1 item from stock
    //commit('products/decrementProductInventory', { id: product.id }, { root: true })
  },
};

// mutations
const mutations = {
  addDishNoPrice(state) {
    state.countDishNoPrice++;
  },

  removeDishNoPrice(state) {
    state.countDishNoPrice--;
  },

  pushProductToCart(state, dish) {
    state.items.push(dish);
    /*
      clone.incremental = dish.incremental;
      clone.menuposition = menu.position;
*/
    state.items.sort(function(a, b) {
      if (a.menuposition > b.menuposition) {
        return 1;
      } else if (a.menuposition < b.menuposition) {
        return -1;
      } else if (a.incremental > b.incremental) {
        return 1;
      } else if (a.incremental < b.incremental) {
        return -1;
      } else {
        return 0;
      }
    });

    state.countDish++;
  },

  incrementItemQuantity(state, cartItem) {
    ////const cartItem = state.items.find((item) => item.id === id);
    cartItem.quantity++;
    state.countDish++;
  },

  decrementItemQuantity(state, cartItem) {
    //const cartItem = state.items.find((item) => item.id === id);
    if (cartItem.quantity > 1) {
      cartItem.quantity--;
    } else {
      let index = -1;
      for (let i = 0; i < state.items.length; i++) {
        ////if (state.items[i].id == id) {
        if (
          state.items[i].id == cartItem.id &&
          state.items[i].menuid == cartItem.menuid
        ) {
          index = i;
          break;
        }
      }
      state.items.splice(index, 1);
    }
    state.countDish--;
  },

  setCartItems(state, items) {
    state.items = items;
  },

  setCountDish(state, count) {
    state.countDish = count;
  },

  setCountDishNoPrice(state, count) {
    state.countDishNoPrice = count;
  },

  setCheckoutStatus(state, status) {
    state.checkoutStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
